export default {
  field: {
    label: 'Kategoria podatkowa',
    placeholder: 'Brak kategorii podatkowej',
    unlinked_hint:
      'Bez niej produkt używa kategorii podatkowej swojej kategorii menu lub standardowej stawki restauracji.',
    default_hint: 'Zapisane bez niej, otrzyma domyślną kategorię podatkową menu.',
  },
  empty: {
    hint: 'Brak kategorii podatkowych — dodaj jedną poniżej.',
    read_only_hint: 'Kategorie podatkowe nie zostały jeszcze skonfigurowane.',
  },
  option: {
    varies_by_channel: '(zależy od kanału)',
  },
  load_error:
    'Nie udało się załadować kategorii podatkowych — łączenie i rozłączanie są wyłączone do czasu załadowania.',
  create: {
    name_placeholder: 'Nazwa nowej kategorii',
    rate_placeholder: 'Stawka %',
    button: 'Dodaj kategorię podatkową',
  },
  toasts: {
    create_error: 'Nie udało się utworzyć kategorii podatkowej.',
  },
};
